import TooltipIconComponent from '@components/TooltipIconComponent/TooltipIconComponent';
import { type FC } from 'react';
import { PiThermometerBold } from 'react-icons/pi';
import { useTheme } from 'context/ThemeProvider/ThemeProvider';
import { SankeyButton } from './styled';

interface BuildingSankeyNonConsumptionButtonProps {
  id: string;
  isSelected: boolean;
  handleSelection: (id: string) => void;
}

const BuildingSankeyNonConsumptionButton: FC<
  BuildingSankeyNonConsumptionButtonProps
> = ({ id, isSelected, handleSelection }) => {
  const { theme } = useTheme();

  return (
    <SankeyButton
      $isSelected={isSelected}
      onClick={() => {
        handleSelection(id);
      }}
      className="min-w-[200px]"
    >
      <div className="flex justify-between items-center">
        <div className="flex gap-2.5 text-base items-center">
          <div>
            <PiThermometerBold fill={theme.colors['gray-50']} size={20} />
          </div>
          <div className="mx-1">Non consumption</div>
        </div>
        <TooltipIconComponent
          color={theme.colors['gray-45']}
          content="The non-consumption of the building are the meters that are not connected to the energy network."
        />
      </div>

      <div className="flex items-center gap-2 justify-between">
        <p className="text-lg font-bold">{`-`}</p>
        <p>
          <span className="flex items-center">
            <p className="text-lg"></p>
          </span>
        </p>
      </div>
    </SankeyButton>
  );
};
export default BuildingSankeyNonConsumptionButton;
